export default {
  group: {
    enumMid: '枚举类型',
    enumName: '枚举名称',
    enumValue: '枚举值',
    status: '状态',
    enumSeq: '排序',
    remarks: '备注',
    addByName: '创建人员',
    adddate: '创建时间',
    updateByName: '更新人员',
    upddate: '更新时间',
    placeholder: '枚举类型/枚举编码/枚举名称'
  }
}
